import Vue from 'vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'select-notice',
    data: function () {
        return {
            usernameZh: '',
            currentMessage: '',
            isImport: false,
            isTry: false,
            isShowFailOpe: false,
            isUploadComplete: false,
            uploadVolidate: false,
            isQuery: true,
            uploadStatus: '',
            templateDownConfig: {
                href: 'javascript:void(0)',
                isDisabled: true,
            },
            downloadUrl: '',
            tipsTxt: '',
            importStatus: {
                errorStatus: false,
                successStatus: false,
                warnStatus: false,
            },
            file: '',
            loading2: false,
            templateCode: '',
        };
    },
    props: {
        uploadUrl: {
            type: String,
            default: '',
        },
        isUpload: {
            type: Boolean,
            default: false,
        },
        clearStatus: {
            type: Boolean,
            default: false,
        },
        fileUrl: {
            type: String,
            default: function () {
                return '';
            },
        },
        isShowDownloadTips: {
            type: Boolean,
            default: true,
        },
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        beforeUploadValidate: function (file) {
            var fileArr = file.name.split('.');
            var name = fileArr[fileArr.length - 1];
            var reg = /^xlsx|xls$/;
            this.isUploadComplete = false;
            if (!reg.test(name)) {
                this.$confirm('', '', {
                    message: '<p class="title">仅支持xlsx或xls格式文件</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '知道了',
                    showClose: false,
                    type: 'error',
                    showCancelButton: false,
                });
                return false;
            }
        },
        customRequest: function (_a) {
            var file = _a.file;
            this.loading2 = true;
            this.file = file;
            this.$emit('get-upload-ele', {
                uploadEle: this,
            });
            this.uploadMsg(this.file);
        },
        uploadError: function () {
            this.tipsTxt = '上传失败,请重试';
            this.isQuery = false;
            this.isImport = true;
            this.isTry = true;
            this.loading2 = false;
            this.importStatus = {
                errorStatus: true,
                successStatus: false,
                warnStatus: false,
            };
            this.$emit('get-uploadKey', {
                uploadKey: '',
                isDisabled: false,
                isQuery: this.isQuery,
            });
            this.$emit('get-upload-ele', {
                uploadEle: this,
            });
        },
        repeatUpload: function () {
            if (this.uploadStatus === 'FAIL') {
                // this.isUpload = true
                this.isTry = false;
                this.isImport = false;
                this.isQuery = true;
                this.loading2 = false;
                this.isShowFailOpe = false;
                this.$emit('get-uploadKey', {
                    uploadKey: '',
                    isDisabled: false,
                    isQuery: this.isQuery,
                });
            }
        },
        uploadMsg: function (file) {
            var _this = this;
            this.$request({
                method: 'post',
                url: "/proxy/vehicle/file/file/upload/violation/batch",
                data: {
                    file: file,
                },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (data[key] != null) {
                            formData.append(key, data[key]);
                        }
                    }
                    return formData;
                },
            }).then(function (res) {
                if (!res || res.errorCode) {
                    _this.$refs['upload-btn'].clearFiles();
                    _this.loading2 = false;
                    _this.isQuery = false;
                    _this.$emit('get-uploadKey', {
                        uploadKey: '',
                        isDisabled: false,
                        isQuery: _this.isQuery,
                    });
                    return;
                }
                return _this.showResult(res.data);
            });
        },
        showResult: function (data) {
            this.loading2 = false;
            var uploadKey = data.uploadKey, result = data.result;
            if (result) {
                this.isImport = true;
                this.isQuery = true;
                this.tipsTxt = '已成功导入';
                this.uploadStatus = 'SUCCESS';
                this.importStatus = {
                    errorStatus: false,
                    successStatus: true,
                    warnStatus: false,
                };
                return this.$emit('get-uploadKey', {
                    uploadKey: uploadKey,
                    isDisabled: true,
                    isQuery: this.isQuery,
                });
            }
            else {
                this.isQuery = false;
                this.isImport = true;
                this.tipsTxt = '导入失败,请点击重试';
                this.isTry = true;
                this.uploadStatus = 'FAIL';
                this.importStatus = {
                    errorStatus: true,
                    successStatus: false,
                    warnStatus: false,
                };
                this.isShowFailOpe = true;
                this.downloadUrl = uploadKey;
                return this.$emit('get-uploadKey', {
                    uploadKey: '',
                    isDisabled: false,
                    isQuery: this.isQuery,
                });
            }
        },
        downloadFail: function () {
            window.open(this.downloadUrl);
        },
    },
    watch: {
        clearStatus: function (val) {
            if (val) {
                this.repeatUpload();
            }
        },
    },
});
